import { Component, ElementRef, Injector, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from '../../common/BaseComponent';
import { UserService } from 'src/app/service/UserService';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/internal/Subscription';
import { ProgressService } from 'src/app/service/ProgressService';
import { Constants } from 'src/app/util/Constants';
import { PasswordValidator } from 'src/app/validator/PasswordValidator';
import { User } from 'src/app/model/user';
import { AdminService } from 'src/app/service/admin/AdminService';
import { UserRoleDetails } from 'src/app/model/userRoleDetails';
import { UserRole } from 'src/app/model/userRole';

@Component({
  selector: 'app-role-admin',
  templateUrl: './role-admin.component.html',
  styles: [
  ]
})
export class RoleAdminComponent extends BaseComponent implements OnInit {
  submitted: boolean = false;
  onRolesLoad: boolean = false;
  roleAdminSearchForm: FormGroup<any>;
  user: User;
  rolesArray: any[] = []; 
  rolesArrayFr: any[] = []; 
  role: any;
  default: string;
  currentLanguage: string;
  private languageChangeSubs: Subscription;
  dataSubscription: Subscription;
  @ViewChild('managerole') managerole: ElementRef;
  pageMsgRendered: boolean;
  @ViewChild('pageMsg') pageMsgElement: ElementRef;
  @ViewChild('progressDialog') progressDialogElementRef!: ElementRef<HTMLDialogElement>;

  constructor (
      injector: Injector, 
      public rest: AdminService,
      public fb: FormBuilder,
      public progressService: ProgressService) {

      super(injector);    
      this.submitted = false;

      //this.roleAdminSearchForm.controls['managerole'].setValue(this.default, {onlySelf: true});
    }

  ngOnInit(): void {
      this.roleAdminSearchForm = new FormGroup({
        managerole: new FormControl(null, Validators.required),    
        firstName: new FormControl(null, Validators.compose([Validators.pattern(Constants.SEARCH_NAME), PasswordValidator.invalidInputAsterisk])),
        lastName: new FormControl(null, Validators.compose([Validators.pattern(Constants.SEARCH_NAME), PasswordValidator.invalidInputAsterisk])),      
        //email: new FormControl(null, PasswordValidator.invalidSearchEmail), //BpsEmailValidator.restricted])),
        email: new FormControl(null, Validators.compose([PasswordValidator.invalidInputAsterisk])), 
        guid: new FormControl(null, Validators.compose([Validators.pattern(/^[^<>()]+$/), PasswordValidator.invalidInputAsterisk]))
        }      
      );  
          

       if (sessionStorage.getItem("searchUserRole") != null) {
          this.loadRolesData();
          let userRoleDetails: UserRoleDetails = new UserRoleDetails();
          let userRole: UserRole = new UserRole();
          //let user: User = new User();

          userRoleDetails = JSON.parse(sessionStorage.getItem("searchUserRole"));

          this.role = userRoleDetails.role.roleName;
          this.user = userRoleDetails.user;
          
          console.log("userSearch FirstName: ",this.user.firstName);
          console.log("roleName: ", this.role);

          this.roleAdminSearchForm.setValue({
            firstName:this.user.firstName || '',
            lastName:this.user.lastName || '',
            email:this.user.email || '',
            guid:this.user.guid || '', 
            managerole: this.role  || ''
          });

          /*
          this.roleAdminSearchForm.patchValue({
            'managerole': this.default
          }); */         
        }
        else {
          this.loadRolesData();
        }
    
  }

  atLeastOneFieldRequired(formGroup: FormGroup) {
    const values = Object.values(formGroup.value);
    const hasAtLeastOneValue = values.some(value => value !== null && value !== '');
    
    return hasAtLeastOneValue ? null : { atLeastOneRequired: true };
  }

  private subscribeToLanguageChange(): void {
    this.languageChangeSubs = this.translator.onLangChange.subscribe(
      () => {
        this.currentLanguage = this.translator.currentLang;
      }
    );
  }

  loadRolesData(): void {

    this.currentLanguage = this.translator.currentLang;
    this.subscribeToLanguageChange();

    
    //this.dataSubscription = this.rest.getUserRoles(this.user).subscribe(
      //this.progressService.open();
      
      this.dataSubscription = this.rest.getRoles().subscribe(
        (response) => {
          if (response.result == 0 && response.count > 0) {
            this.rolesArray = response['manageRoles'];  
            console.log("Roles EN: " + this.rolesArray);
          }
          else if (response.result == 1 || response.count == 0) {
            this.appError = this.onRolesLoad = true;
            this.appErrorMessage = "bss.roleAdminSearch.error.loadRoles";
            console.log("RoleAdmin Search:: appError: " + this.appError);
            console.log("RoleAdmin Search:: appErrorMessage: " + this.appErrorMessage);
            console.error('RoleAdmin Search :: Error fetching Roles data');
            return;
          } 
          else  {        
            console.error("RoleAdmin Search:: Error encountered retreiving roles");
            this.router.navigate(['public/error']);
          }
      },
      /*
      this.dataSubscription = this.rest.getRoles().subscribe(
      (data: any[]) => {
          this.rolesArray = data['manageRoles'];

          //this.rolesArrayFr = data['manageRoles-fr'];
          console.log("Roles EN: " + this.rolesArray);
          //console.log("Roles FR: " + this.rolesArrayFr);
      }, */
      error => {
        console.error('Error fetching data:', error);
      }
      /*,      
    () => {
      this.progressService.close();
    } */
    );

    this.roleAdminSearchForm.patchValue({
      'role': this.default
    });
    
  }

  get currentRolesArray() {
    //return this.currentLanguage === 'fr' ? this.rolesArrayFr : this.rolesArray;
    return this.rolesArray;
  }

  onSearch(): void {
    console.log("Selected Role: " + this.role );
    this.submitted = true;
    this.appError = false; 
   
    let userRoleDetails: UserRoleDetails = new UserRoleDetails();
    let userRole: UserRole = new UserRole();
    let user: User = new User();

    user.firstName = this.roleAdminSearchForm.get("firstName").value;     
    user.lastName = this.roleAdminSearchForm.get("lastName").value;
    user.email = this.roleAdminSearchForm.get("email").value;
    user.guid = this.roleAdminSearchForm.get("guid").value;

    console.log("Values entered: " + JSON.stringify(user));

      // Check if at least one text field is populated
    const isAtLeastOneTextFieldPopulated =
    user.firstName || user.lastName || user.email || user.guid;

    // Check if the form is valid (dropdown is selected and at least one text field is populated)
    if (this.roleAdminSearchForm.valid && isAtLeastOneTextFieldPopulated) {
      // Your search logic here
      console.log('Valid Search parameters provided to Search!');
    } else {
      // Display an error message or take appropriate action
      console.log('Invalid form or no search parameters populated.');
    }

    if (!isAtLeastOneTextFieldPopulated) {
      this.appError = true;          
      this.appErrorMessage = "bss.roleAdminSearch.text.noSearchValue";
      console.log("RoleAdmin Search:: appError: " + this.appError);
      console.log("RoleAdmin Search:: appErrorMessage: " + this.appErrorMessage);
      return;
    }

    //sessionStorage.setItem("selectedRole", this.role);
    //sessionStorage.setItem("selectedUser", JSON.stringify(userSearch));

    userRole.roleName = this.role;
    userRoleDetails.role = userRole;
    userRoleDetails.user = user;

    sessionStorage.setItem("searchUserRole", JSON.stringify(userRoleDetails));

    this.router.navigate(['secure/paadmin/selectUserAccount/']); 

    // Post the captured search parameter values to the backend
  }

  onResetWin(): void {
    this.router.navigate(['secure/paadmin/resetWinRegLock/']);
  }
  
  onSelected(value:string): void {
      this.role = value;
    }
    
  ngOnDestroy() {
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
    if(this.languageChangeSubs){
      this.languageChangeSubs.unsubscribe();
    }
  }

  ngAfterViewInit() {
    this.progressService.setDialog(this.progressDialogElementRef.nativeElement);
    //this.progressService.setDialog(this.progressDialogElementRef.nativeElement);
  }

  ngAfterViewChecked() {
    if (!this.pageMsgRendered && this.pageMsgElement !== undefined) {
      this.pageMsgElement.nativeElement.focus();
      this.pageMsgElement.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
      this.pageMsgRendered = true;
    }
  }
  }


